import React from 'react';

function Delete({ image, name, category,onDelete, onCancel }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/30  z-50">
      {/* Overlay for background blur effect */}
      <div className="fixed inset-0 bg-black/30 "></div>

      <div className="relative z-10 w-[300px] p-6 border rounded-md shadow-lg bg-white">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-semibold">Delete Confirmation</h2>
          <i
            className="fa fa-times text-xl cursor-pointer hover:text-red-600"
            aria-hidden="true"
            onClick={onCancel}
          ></i>
        </div>

        <div className="flex flex-col items-center mt-4">
          <img
            src={image}
            alt={name}
            className="w-24 h-24 object-contain rounded-md mb-4"
          />
          <p className="text-center mb-4">
            Are you sure you want to delete <strong>{name} {category}</strong>?
          </p>
        </div>

        <div className="flex justify-center gap-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={onDelete}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default Delete;
